import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import {
  AppConfigProvider,
  Auth0ProviderWithNavigate,
  AuthenticationGuard,
  EnvConfigProvider,
} from "rwo-react";
import { App } from "./App";
import "./assets/css/App.css";
import { LoadingPage } from "./components/LoadingPage";
import { PostLogoutHandler } from "./components/PostLogoutHandler";
import { initializeI18n } from "./localization";
import { theme } from "./theme";
import { InstructionsPage } from "./components/InstructionsPage";
import { NewInstructionsPage } from "./components/NewInstructionsPage";

initializeI18n();

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
const client = new QueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <EnvConfigProvider config={process.env} devUri="http://localhost:3000">
        <QueryClientProvider client={client}>
          <NewInstructionsPage />
          {/* <BrowserRouter>
            <Auth0ProviderWithNavigate cacheType="sessionstorage">
              <PostLogoutHandler loadingPage={<LoadingPage />}>
                <AuthenticationGuard loadingPage={<LoadingPage />}>
                  <AppConfigProvider loadingFallback={<LoadingPage />}>
                    <App />
                  </AppConfigProvider>
                </AuthenticationGuard>
              </PostLogoutHandler>
            </Auth0ProviderWithNavigate>
          </BrowserRouter> */}
        </QueryClientProvider>
      </EnvConfigProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
